// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"373":"2ad2fdab","503":"dfe177ec","918":"41d646ae"}[chunkId] + ".chunk.css";
};